import React from "react";
import PropTypes from 'prop-types'
import { ActionButtonTheme } from "../../pages/Theme";

const ActionButton = ({ onClick, title, style, textStyle, disabled, ...props }) => {
    return (
        title === "Processing..." ?
            <ActionButtonTheme
                className={`flex flex-row cursor-pointer rounded-lg border-2 p-3 h-1 px-3
                        items-center justify-center w-flex filter drop-shadow-sm ${style} cursor-not-allowed pointer-events-none`}
                onClick={onClick}
            >
                <p className={`${"font-semibold text-xs pt-0.5 whitespace-nowrap"} ${textStyle}`}>{title}</p>
            </ActionButtonTheme>
            :
            <ActionButtonTheme
                className={`flex flex-row rounded-lg border-2 p-3 h-1 px-3
                        items-center justify-center w-flex filter drop-shadow-sm ${style} ${disabled ? `cursor-not-allowed pointer-events-none` : `cursor-pointer`}`}
                onClick={onClick}
            >
                <p className={`${"font-semibold text-xs pt-0.5 whitespace-nowrap"} ${textStyle}`}>{title}</p>
            </ActionButtonTheme>
    )
}
ActionButton.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
}

export default ActionButton
